import axios from 'axios';
import apiCall from '../../../utils/api/api';
import {
  SET_CANCEL_TOKEN,
} from '../../actions/peopleActions/people';
import {
  SET_GENRE_STORE_PROPERTY,
  GET_GENRES_REQUEST,
  GET_GENRES_SUCCESS,
  GET_GENRES_ERROR,
  ADD_GENRE_REQUEST,
  ADD_GENRE_SUCCESS,
  ADD_GENRE_ERROR,
  GET_GENRE_IN_USE_STATUS_REQUEST,
  GET_GENRE_IN_USE_STATUS_SUCCESS,
  GET_GENRE_IN_USE_STATUS_ERROR,
  CHANGE_GENRE_STATUS_REQUEST,
  CHANGE_GENRE_STATUS_SUCCESS,
  CHANGE_GENRE_STATUS_ERROR,
  DELETE_GENRE_REQUEST,
  DELETE_GENRE_SUCCESS,
  DELETE_GENRE_ERROR,
  GET_GENRE_REQUEST,
  GET_GENRE_SUCCESS,
  GET_GENRE_ERROR,
  EDIT_GENRE_REQUEST,
  EDIT_GENRE_SUCCESS,
  EDIT_GENRE_ERROR,
  GET_GENRES_FOR_CHOICE_REQUEST,
  GET_GENRES_FOR_CHOICE_SUCCESS,
  GET_GENRES_FOR_CHOICE_ERROR,
} from '../../actions/genres/genresActions';

const state = {
  isLoading: false,
  genres: [],
  pagination: {},
  genre: {},
  source: null,
  filterValue: '',
  sortFiled: 'g.name',
  sortBy: 'ASC',
};

const actions = {
  [GET_GENRES_REQUEST]: ({ commit }, params) => new Promise((resolve) => {
    commit(GET_GENRES_REQUEST);
    if (state.source) {
      state.source.cancel();
    }

    const { CancelToken } = axios;
    const source = CancelToken.source();
    commit(SET_CANCEL_TOKEN, { token: source });

    let url = `${params.accountId}/taxonomy/genre?p=${params.page}&l=15&filterField=g.name&filterValue=${state.filterValue}`;
    if (state.sortFiled) {
      url += `&s=${state.sortFiled}&d=${state.sortBy}`;
    }

    apiCall.get(url, { cancelToken: source.token })
      .then((resp) => {
        commit(GET_GENRES_SUCCESS, resp.data);
        resolve();
      })
      .catch(() => {
        commit(GET_GENRES_ERROR);
      });
  }),
  [GET_GENRE_IN_USE_STATUS_REQUEST]: ({ commit }, params) => new Promise((resolve) => {
    commit(GET_GENRE_IN_USE_STATUS_REQUEST);

    const url = `${params.accountId}/taxonomy/genre/${params.id}/is-in-use`;

    apiCall.get(url)
      .then((resp) => {
        commit(GET_GENRE_IN_USE_STATUS_SUCCESS, resp.data);
        resolve(resp.data);
      })
      .catch(() => {
        commit(GET_GENRE_IN_USE_STATUS_ERROR);
        resolve({ isInUse: true });
      });
  }),
  [ADD_GENRE_REQUEST]: ({ commit }, { accountId, data }) => new Promise((resolve, reject) => {
    commit(ADD_GENRE_REQUEST);

    apiCall.post(`${accountId}/taxonomy/genre`, data)
      .then((res) => {
        commit(ADD_GENRE_SUCCESS, res.data);
        resolve(res.data);
      })
      .catch((err) => {
        const error = err.response.data;
        commit(ADD_GENRE_ERROR, error);
        reject(error);
      });
  }),
  [GET_GENRE_REQUEST]:
    ({ commit }, { accountId, genreId }) => new Promise((resolve, reject) => {
      commit(GET_GENRE_REQUEST);

      const url = `${accountId}/taxonomy/genre/${genreId}`;

      apiCall.get(url)
        .then((resp) => {
          commit(GET_GENRE_SUCCESS, resp.data);
          resolve(resp.data);
        })
        .catch((err) => {
          const error = err.response.data;
          commit(GET_GENRE_ERROR, error);
          reject(error);
        });
    }),
  [CHANGE_GENRE_STATUS_REQUEST]:
    ({ commit }, { accountId, genreId, data }) => new Promise((resolve, reject) => {
      commit(CHANGE_GENRE_STATUS_REQUEST);

      apiCall.put(`${accountId}/taxonomy/genre/${genreId}/enabled`, data)
        .then((resp) => {
          commit(CHANGE_GENRE_STATUS_SUCCESS, resp);
          resolve(resp);
        })
        .catch((err) => {
          const error = err.response.data;
          commit(CHANGE_GENRE_STATUS_ERROR, error);
          reject(error);
        });
    }),
  [DELETE_GENRE_REQUEST]:
    ({ commit }, { accountId, genreId }) => new Promise((resolve, reject) => {
      commit(DELETE_GENRE_REQUEST);

      const url = `${accountId}/taxonomy/genre/${genreId}`;

      apiCall.delete(url)
        .then(() => {
          commit(DELETE_GENRE_SUCCESS);
          resolve();
        })
        .catch((error) => {
          commit(DELETE_GENRE_ERROR, error);
          reject(error);
        });
    }),
  [EDIT_GENRE_REQUEST]:
    ({ commit }, { accountId, genreId, data }) => new Promise((resolve, reject) => {
      commit(EDIT_GENRE_REQUEST);

      const url = `${accountId}/taxonomy/genre/${genreId}`;

      apiCall.put(url, data)
        .then(() => {
          commit(EDIT_GENRE_SUCCESS);
          resolve();
        })
        .catch((err) => {
          const error = err.response.data;
          commit(EDIT_GENRE_ERROR, error);
          reject(error);
        });
    }),
  [GET_GENRES_FOR_CHOICE_REQUEST]:
    ({ commit }, { accountId }) => new Promise((resolve, reject) => {
      commit(GET_GENRES_FOR_CHOICE_REQUEST);

      const url = `choice/accounts/${accountId}/genres`;

      apiCall.get(url)
        .then((resp) => {
          commit(GET_GENRES_FOR_CHOICE_SUCCESS, resp.data);
          resolve(resp.data);
        })
        .catch((err) => {
          const error = err.response.data;
          commit(GET_GENRES_FOR_CHOICE_ERROR, error);
          reject(error);
        });
    }),
};

const mutations = {
  [SET_GENRE_STORE_PROPERTY]: (state, payload) => {
    state[payload.key] = payload.value;
  },
  [GET_GENRES_REQUEST]: (state) => {
    state.isLoading = true;
  },
  [GET_GENRES_SUCCESS]: (state, payload) => {
    state.genres = payload.data;
    state.pagination = payload.pagination;
    state.source = null;
    state.isLoading = false;

    localStorage.setItem('genres', payload.pagination.page);
  },
  [GET_GENRES_ERROR]: (state) => {
    state.isLoading = false;
  },
  [GET_GENRE_IN_USE_STATUS_REQUEST]: () => {
    state.isLoading = true;
  },
  [GET_GENRE_IN_USE_STATUS_SUCCESS]: (state) => {
    state.isLoading = false;
  },
  [GET_GENRE_IN_USE_STATUS_ERROR]: (state) => {
    state.isLoading = false;
  },
  [ADD_GENRE_REQUEST]: () => {
    state.isLoading = true;
  },
  [ADD_GENRE_SUCCESS]: () => {
    state.isLoading = false;
  },
  [ADD_GENRE_ERROR]: () => {
    state.isLoading = false;
  },
  [CHANGE_GENRE_STATUS_REQUEST]: () => {
    state.isLoading = true;
  },
  [CHANGE_GENRE_STATUS_SUCCESS]: () => {
    state.isLoading = false;
  },
  [CHANGE_GENRE_STATUS_ERROR]: () => {
    state.isLoading = false;
  },
  [GET_GENRE_REQUEST]: () => {
    state.isLoading = true;
  },
  [GET_GENRE_SUCCESS]: (stateLocal, payload) => {
    state.genre = payload;
    state.isLoading = false;
  },
  [GET_GENRE_ERROR]: () => {
    state.isLoading = false;
  },
  [SET_CANCEL_TOKEN]: (stateLocal, payload) => {
    state.source = payload.token;
  },
  [DELETE_GENRE_REQUEST]: () => {
    state.isLoading = true;
  },
  [DELETE_GENRE_SUCCESS]: () => {
    state.isLoading = false;
  },
  [DELETE_GENRE_ERROR]: () => {
    state.isLoading = false;
  },
  [EDIT_GENRE_REQUEST]: () => {
    state.isLoading = true;
  },
  [EDIT_GENRE_SUCCESS]: () => {
    state.isLoading = false;
  },
  [EDIT_GENRE_ERROR]: () => {
    state.isLoading = false;
  },
  [GET_GENRES_FOR_CHOICE_REQUEST]: () => {
    state.isLoading = true;
  },
  [GET_GENRES_FOR_CHOICE_SUCCESS]: () => {
    state.isLoading = false;
  },
  [GET_GENRES_FOR_CHOICE_ERROR]: () => {
    state.isLoading = false;
  },
};

export default {
  state,
  actions,
  mutations,
};
